import { z } from 'zod'

export const usedCourtesyNameSchema = z.object({
  /** 項目名稱[英文] */
  englishName: z.string(),
  /** 項目名稱[簡體中文] */
  simplifiedName: z.string(),
  /** 項目名稱[繁體中文] */
  traditionalName: z.string()
})

export interface UsedCourtesyName
  extends z.infer<typeof usedCourtesyNameSchema> {}
